import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addPage({ commit }, item) {
    return this.$axios.$post('admin/pages/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removePage({ commit }, item) {
    return this.$axios.$delete(`admin/pages/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updatePage({ commit }, item) {
    return this.$axios.$put(`admin/pages/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchPage({ commit }, id) {
    return this.$axios.$get(`admin/pages/${id}`).then((response) => {
      return response.data
    })
  },
  fetchPages({ commit }) {
    return this.$axios.$get('admin/pages').then((response) => {
      commit('load', response.data)
    })
  },
}
